import React, { useEffect, useState } from 'react';
import { Modal, Form } from 'react-bootstrap'
import CurrencyFormat from './CurrencyFormat';
import downloadImage from "../assets/download.svg";
import fileSaver from "file-saver";
import { extractURLAndEncodedFilename } from '../utils/helper';
import { toast } from "react-toastify";
import { updateBillShipData, updateConsignMentPhotoFromSupplier, updateQualityDocsFromSupplier } from '../utils/actions/userActions';
import deleteImageEnabled from "../assets/blackdelete.svg";
import ConsignmentPhotoViewer from './ConsignmentPhotoViewer';
import { DownloadIcon } from './icons';

const BillDisplayModal = ({ show, handleClose, billData, supplierRFQData, updateBillsForPO }) => {


    const [isModalVisible, setisModalVisible] = useState(true);

    const token = localStorage.getItem('Token');
    const download = async (name, url) => {
        const data = extractURLAndEncodedFilename(url);
        let fileUrl = `${data.url}/${data.encodedFilename}`;
        fileSaver.saveAs(fileUrl, name);
    };

    const [newBillData, setNewBillData] = useState({
        shippedDate: billData?.shippedDate,
        shippingCarrier: billData?.shippingCarrier,
        deliveryTrackingLink: billData?.deliveryTrackingLink,
        billDocument: billData?.billDocument,
        isNoConsignments: billData?.isNoConsignments,
        consignmentPhotos: billData?.consignmentPhotos,
        isNoQCDoc: billData?.isNoQCDoc,
        billQualityDocuments: billData?.billQualityDocuments,
    })


    const [qualityDocObject, setQualityDocObject] = useState({
        name: "",
        file: null,
    });

    useEffect(() => {
        setNewBillData({
            shippedDate: billData?.shippedDate,
            shippingCarrier: billData?.shippingCarrier,
            deliveryTrackingLink: billData?.deliveryTrackingLink,
            billDocument: billData?.billDocument,
            isNoConsignments: billData?.isNoConsignments,
            consignmentPhotos: billData?.consignmentPhotos || [],
            isNoQCDoc: billData?.isNoQCDoc,
            billQualityDocuments: billData?.qualityDocuments || [],
        })

    }, [billData])


    const handleConsignmentPhotosUpload = async (e) => {
        e.preventDefault(); // Prevents default form submission behavior

        const files = e.target.files;
        const userId = localStorage.getItem("_id");
        const email = localStorage.getItem("email");

        // Push event to dataLayer if condition is met
        if (window.location.host === "sc.dainsta.com") {
            window?.dataLayer?.push({
                event: "uploadConsignmentPhotos",
                userId: userId,
                purchaseOrderRefId: billData?.purchaseOrderId?.pORefId,
                billNumber: billData.billNumber,
                referenceId: email?.split('@')[0] + email?.split('@')[1]?.split(".")[0],
            });
        }

        // Construct consignmentPhotoData array
        const consignmentPhotoData = [
            ...newBillData?.consignmentPhotos,
            ...files, // Add new files to existing consignmentPhotos
        ];

        // Create FormData object and append data
        const formDataForCP = new FormData();
        formDataForCP.append("billId", billData._id);
        formDataForCP.append("consignmentPhotoData", JSON.stringify(consignmentPhotoData));
        for (let i = 0; i < consignmentPhotoData.length; i++) {
            formDataForCP.append("billConsigmentPhotos", consignmentPhotoData[i]);
        }


        try {
            // Call API to update consignment photos
            const updateCPResponse = await updateConsignMentPhotoFromSupplier(token, formDataForCP);
            if (updateCPResponse?.status) {
                setNewBillData({
                    ...newBillData,
                    consignmentPhotos: updateCPResponse?.data?.consignmentPhotos,
                });

                updateBillsForPO({ ...billData, ...newBillData, consignmentPhotos: consignmentPhotoData, });
                toast.success(updateCPResponse.message);
            }
        } catch (error) {
            console.error("Error uploading consignment photos:", error);
            toast.error("Failed to upload consignment photos");
        }
    };


    const handleBillUpdateClick = async () => {
        try {


            let data = {
                _id: billData._id,
                ...newBillData,
            }
            const billUpdateResponse = await updateBillShipData(token, data)
            if (billUpdateResponse?.status) {
                toast.success(billUpdateResponse.message);
                handleClose();
                updateBillsForPO({ ...billUpdateResponse.data });
            }

        } catch (e) {
            toast.error(e.message)
        }
    }



    const handleQualityDocumentDelete = async (index) => {
        const updatedDocuments = newBillData.billQualityDocuments.filter((_, i) => i !== index);

        let formData = new FormData();
        formData.append("billId", billData._id);
        formData.append("qualityDoc", JSON.stringify(updatedDocuments));
        updatedDocuments.forEach((val, i) => {
            formData.append("fileToUpload", val.file);
        });

        const qualityDocResponse = await updateQualityDocsFromSupplier(
            token,
            formData
        );

        console.log('qualityDocResponse', qualityDocResponse)
        if (qualityDocResponse.status) {
            setNewBillData({ ...newBillData, billQualityDocuments: qualityDocResponse.data.qualityDocuments })
            setQualityDocObject({
                name: "",
                file: null,
            })

            updateBillsForPO({ ...billData, ...newBillData, qualityDocuments: qualityDocResponse.data.qualityDocuments });
            toast.success("Quality documents deleted successfully");
        }
    }
    const handleQualityDocsUpload = async (file) => {
        try {
            if (!qualityDocObject.name || !file) {
                toast.error("Document name and file are required.");
                return;
            }
            const userId = localStorage.getItem("_id");
            const email = localStorage.getItem("email");


            if (window.location.host === "sc.dainsta.com") {
                window?.dataLayer?.push({
                    event: "uploadQualityDocuments",
                    userId: userId,
                    purchaseOrderRefId: billData?.purchaseOrderId?.pORefId,
                    billNumber: billData?.billNumber,
                    referenceId: email?.split('@')[0] + email?.split('@')[1]?.split(".")[0],
                });
            }

            let localQualityDoc = [...newBillData.billQualityDocuments];
            localQualityDoc.push({ ...qualityDocObject, file });

            let formData = new FormData();
            formData.append("billId", billData._id);
            formData.append("qualityDoc", JSON.stringify(localQualityDoc));
            localQualityDoc.forEach((val, i) => {
                formData.append("fileToUpload", val.file);
            });

            const qualityDocResponse = await updateQualityDocsFromSupplier(
                token,
                formData
            );

            if (qualityDocResponse.status) {
                setNewBillData({ ...newBillData, billQualityDocuments: qualityDocResponse.data.qualityDocuments })
                setQualityDocObject({
                    name: "",
                });

                updateBillsForPO({ ...billData, ...newBillData, qualityDocuments: qualityDocResponse.data.qualityDocuments });
            }

        } catch (err) {
            console.log("err", err);
            return;
        }
    }

    return (
        <div>

            <Modal
                size="xl"
                aria-labelledby="example-custom-modal-styling-title"
                centered
                show={show}
                onHide={handleClose}
                style={{ visibility: isModalVisible ? "visible" : "hidden", width: "100vw" }}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '15px' }}>Invoice details : {billData?.billNumber} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="bill-form-container" style={{ marginBottom: '10px' }}>
                            <div className="bill-form-row">
                                <div>
                                    <label>Status:  {billData?.status}</label>

                                </div>
                            </div>
                        </div>
                        <div className="table-container" >
                            <table style={{ border: "1px solid gray" }}>
                                <thead>
                                    <tr>
                                        <th>Part Name</th>
                                        <th>Description</th>
                                        <th>Part Notes</th>
                                        <th>Order Qty</th>
                                        <th>Invoice Qty</th>
                                        <th>Unit Price</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {supplierRFQData?.partsData?.length > 0 &&
                                        supplierRFQData?.partsData?.map((item, index) => {
                                            return (
                                                <tr key={index} style={{}}>
                                                    <td style={{ minWidth: "80px", textAlign: 'center' }}>

                                                        {item?.partName
                                                            ? item?.partName
                                                            : "Not found"}

                                                    </td>
                                                    <td style={{ minWidth: "250px", paddingLeft: '3px' }}>
                                                        {supplierRFQData?.selectedProcess >= 3 ? (
                                                            <>{item?.description}</>
                                                        ) : (
                                                            <>
                                                                <ul
                                                                    style={{
                                                                        listStyle: "none",
                                                                        padding: 0,
                                                                        margin: 0,
                                                                    }}
                                                                >
                                                                    {item?.description}
                                                                    {item?.materialType ? (
                                                                        <li>
                                                                            {item?.materialType}{" "}
                                                                            {item?.subMaterial
                                                                                ? ", " + item?.subMaterial
                                                                                : ""}
                                                                        </li>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </ul>
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <p className="amt">{item?.partNotes}</p>
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>

                                                        {item?.qty}

                                                    </td>



                                                    <td style={{ textAlign: "center" }}>

                                                        {billData?.partsData?.filter(billPart => billPart?.partItemId == item._id)[0]?.shippedQty}

                                                    </td>

                                                    <td style={{ textAlign: "center" }}>
                                                        {" "}
                                                        €{" "}
                                                        <CurrencyFormat
                                                            amount={Number(item?.price).toFixed(2)}
                                                        />

                                                    </td>

                                                    <td style={{ textAlign: "center" }}>
                                                        €{" "}
                                                        <CurrencyFormat
                                                            amount={Number(
                                                                (billData?.partsData?.filter(billPart => billPart?.partItemId == item._id)[0]?.shippedQty || 0) *
                                                                item.price
                                                            )}
                                                        />

                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    <tr className="heading-row">
                                        <td scope="col"></td>
                                        <td scope="col"></td>
                                        <td scope="col"></td>
                                        <td scope="col"></td>
                                        <td scope="col"></td>
                                        <td scope="col" style={{ fontWeight: "bolder" }}>
                                            Total Amount
                                        </td>
                                        <td scope="col" style={{ textAlign: "center" }}>
                                            €{" "}
                                            <CurrencyFormat
                                                amount={Number(billData?.billTotalAmount).toFixed(2)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="bill-form-container">
                            <div className="bill-form-row">
                                <div>
                                    <label htmlFor="billNumber"> Invoice Number:</label>
                                    <Form.Control
                                        id="billNumber"
                                        type="text"
                                        value={billData?.supplierBillNumber}
                                        disabled
                                    />
                                </div>



                                <div>
                                    <label htmlFor="billShippingDate"> Shipping Date:</label>
                                    <Form.Control
                                        id="billShippingDate"
                                        type="date"
                                        value={newBillData?.shippedDate ? new Date(newBillData?.shippedDate)
                                            .toISOString()
                                            .slice(0, 10)
                                            : ""}
                                        disabled={billData?.status != 'pending for approval'}
                                        onChange={(e) => setNewBillData({ ...newBillData, shippedDate: e.target.value })}
                                    />
                                </div>

                                <div>
                                    <label htmlFor="billShippingCarrier"> Shipping Carrier:</label>
                                    <Form.Control
                                        id="billShippingCarrier"
                                        type="text"
                                        disabled={billData?.status != 'pending for approval'}
                                        value={newBillData?.shippingCarrier}
                                        onChange={(e) => setNewBillData({ ...newBillData, shippingCarrier: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="bill-form-row">
                                <div>
                                    <label htmlFor="billTrackingNumber"> Tracking Number:</label>
                                    <Form.Control
                                        id="billTrackingNumber"
                                        type="text"
                                        disabled={billData?.status != 'pending for approval'}
                                        value={newBillData?.deliveryTrackingLink}
                                        onChange={(e) => setNewBillData({ ...newBillData, deliveryTrackingLink: e.target.value })}
                                    />
                                </div>

                                <div>
                                    <label htmlFor="billDocument">Invoice Document:</label>
                                    <br />
                                    {billData?.billDocument?.name || billData?.billDocument?.originalname ? (
                                        <>
                                            {billData?.billDocument?.name ? <>
                                                <a
                                                    className="downloadables flex items-center justify-start gap-x-2"
                                                    href={URL.createObjectURL(billData?.billDocument)}
                                                    download={billData?.billDocument?.filename}
                                                    target="_blank"
                                                    style={{ fontSize: "12px" }}
                                                >
                                                    <span>{billData?.billDocument?.name}</span>
                                                    <DownloadIcon />
                                                </a></>
                                                :
                                                <></>
                                            }

                                            {billData?.billDocument?.originalname && (
                                                <span
                                                    className="downloadables flex items-center justify-start gap-x-2"
                                                    style={{ fontSize: "12px" }}
                                                    onClick={() => {
                                                        let url = `${process.env.REACT_APP_API_ENDPOINT}/${billData?.billDocument?.path}`;
                                                        download(billData?.billDocument?.originalname, url);
                                                    }}
                                                >
                                                    <span>{billData?.billDocument?.originalname}</span>
                                                    <DownloadIcon additionalClass={'!h-4'} />
                                                </span>
                                            )}



                                        </>
                                    ) : (
                                        <>
                                            <label
                                                className="white-btn"
                                                style={{
                                                    margin: "0px",
                                                    border: "1px solid #b4b4b4",
                                                    color: "#2B96DC",
                                                }}
                                                htmlFor={`upload-bill-doc`}
                                            >
                                                Upload Invoice Document
                                            </label>
                                            <Form.Control
                                                id={`upload-bill-doc`}
                                                type="file"
                                                style={{ visibility: "hidden" }}
                                            />
                                        </>
                                    )}
                                </div>

                                <div>
                                    <label htmlFor="remittanceDate"> Remittance Date:</label>
                                    <Form.Control
                                        id="remittanceDate"
                                        type="date"
                                        value={billData?.remittanceDate}
                                        disabled
                                    />
                                </div>
                            </div>

                            <div className="bill-form-row">
                                <div>
                                    <label htmlFor="billDate">Consignment Photos:</label>
                                    <div >
                                        <input
                                            type="checkbox"
                                            checked={newBillData?.isNoConsignments}
                                            onChange={() => setNewBillData({ ...newBillData, isNoConsignments: !newBillData?.isNoConsignments })}
                                            id="consign-check"
                                        />
                                        <label htmlFor="consign-check" className="check-label">Please check this box to confirm that there are no consignment photos to be uploaded with this invoice.Note that incorrect selection might lead to invoice rejection.</label>
                                    </div>
                                    {(billData?.status != 'approved' && billData?.status != 'paid' && !newBillData?.isNoConsignments) ?
                                        <>
                                            <label
                                                className="bill-button"
                                                htmlFor={`upload-bill-conginments-photos`}
                                            >
                                                Upload
                                            </label>
                                            <Form.Control
                                                id={`upload-bill-conginments-photos`}
                                                type="file"
                                                style={{ visibility: "hidden" }}
                                                multiple={true}
                                                onChange={(e) => {
                                                    let filesForCheck = Array.from(e.target.files);
                                                    let isAllFilesValid = true;
                                                    filesForCheck.forEach(file => {
                                                        if (file.size > 10000000) {
                                                            isAllFilesValid = false;
                                                        }
                                                    })

                                                    if (!isAllFilesValid) {
                                                        toast.error("File size should be less than 10 MB");
                                                        return;
                                                    }
                                                    handleConsignmentPhotosUpload(e)
                                                }
                                                }
                                                accept="image/*"
                                            />
                                        </> : <></>}

                                </div>
                            </div>

                            <div className="bill-form-container">
                                <div className="bill-form-row">
                                    {newBillData?.consignmentPhotos?.length > 0 ?
                                        <>
                                            <span>
                                                <ConsignmentPhotoViewer parentModalVisibilityFunction={setisModalVisible} images={newBillData?.consignmentPhotos} altText={`image`} />
                                            </span>
                                        </>
                                        : <></>}


                                </div>
                            </div>
                            <div className="bill-form-container my-2">
                                <div className="bill-form-row">

                                    <div>
                                        <div style={{ display: "flex" }}>
                                            <input
                                                type="checkbox"
                                                checked={newBillData?.isNoQCDoc}
                                                onChange={() => setNewBillData({ ...newBillData, isNoQCDoc: !newBillData.isNoQCDoc })}
                                                id='quality-check'
                                            />
                                            <label htmlFor="quality-check" ></label>
                                            <p className="check-label">Please check this box to confirm that there are no quality document to be uploaded with this invoice.Note that incorrect selection might lead to invoice rejection.</p>
                                        </div>
                                   {!newBillData.isNoQCDoc &&     <label htmlFor="dueDate">Quality Documents:</label>}
                                 {!newBillData.isNoQCDoc &&        <div
                                            className="col"
                                            style={{
                                                display: "flex",
                                                flexBasis: "45%",
                                            }}
                                        >
                                            <div className="col">
                                                <label>Document Name:</label>
                                                {billData?.status == 'pending for approval' ?
                                                    <>
                                                        <div
                                                            
                                                            className=' flex justify-start gap-x-2 items-center'
                                                        >
                                                            <div className="col">
                                                                <div className="desc-part w-full">
                                                                    <Form.Control
                                                                        className='!border ms-2'
                                                                        type="text"
                                                                        name="document-name"
                                                                        placeholder="Enter document name here"
                                                                        value={qualityDocObject.name || ""}
                                                                        style={{ marginLeft: '-5px' }}
                                                                        onChange={(e) =>
                                                                            setQualityDocObject({
                                                                                ...qualityDocObject,
                                                                                name: e.target.value,
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className=" quality-doc-div-po">
                                                                {!(
                                                                    qualityDocObject?.file?.filename ||
                                                                    qualityDocObject?.file?.name
                                                                ) && qualityDocObject.name ? (
                                                                    <div className=''>
                                                                        <label
                                                                            className="bill-button"
                                                                            htmlFor={`uploadDoc`}
                                                                        >
                                                                            Upload
                                                                        </label>
                                                                        <Form.Control
                                                                            
                                                                            id={`uploadDoc`}
                                                                            className="quality-doc-item-input absolute"
                                                                            type="file"
                                                                            onChange={async (e) => {
                                                                                let filesForCheck = Array.from(e.target.files);
                                                                                let isAllFilesValid = true;
                                                                                filesForCheck.forEach(file => {
                                                                                    if (file.size > 10000000) {
                                                                                        isAllFilesValid = false;
                                                                                    }
                                                                                })


                                                                                if (!isAllFilesValid) {
                                                                                    toast.error("File size should be less than 10 MB");
                                                                                    return;
                                                                                }
                                                                                const files = e.target.files[0];
                                                                                try {
                                                                                    await handleQualityDocsUpload(files);

                                                                                } catch (error) {
                                                                                    toast.error("Unable To Upload Documents");
                                                                                }
                                                                            }}
                                                                            accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "flex-start",
                                                                            marginBottom: "10px",
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="downloadables"
                                                                            style={{
                                                                                marginRight: "40px",
                                                                                fontSize: "12px",
                                                                                padding: "5px 10px",
                                                                            }}
                                                                        >

                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* <div className="col quality-doc-div-po">
                                                                <div>
                                                                    <button
                                                                        className="bill-button"
                                                                        style={{ width: "120px", backgroundColor: 'white' }}
                                                                        onClick={handleQualityDocsUpload}
                                                                    >
                                                                        Add
                                                                    </button>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                    </> : <></>}

                                                {newBillData?.billQualityDocuments?.length > 0 ? (
                                                    <>
                                                        <div className="address-bar">
                                                            <div className="billing-form">
                                                                <div className="address">
                                                                    {newBillData?.billQualityDocuments?.map(
                                                                        (item, i) => {
                                                                            return (
                                                                                <div
                                                                                    className="singleAddress"
                                                                                    key={i}
                                                                                    style={{
                                                                                        marginTop: "10px",
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        style={{
                                                                                            display: "flex",
                                                                                        }}
                                                                                    >
                                                                                        <div className="address">
                                                                                            <div className="name ">
                                                                                                <span className='font-bold'>Name :</span>
                                                                                                {item.name}
                                                                                            </div>
                                                                                            <div className="add flex">
                                                                                                <span className='font-bold'>File : </span>
                                                                                                {item.file?.filename ? (
                                                                                                    <span>
                                                                                                        <a
                                                                                                            className="downloadables flex items-center gap-x-2"
                                                                                                            href={
                                                                                                                item.file?.name
                                                                                                                    ? URL.createObjectURL(
                                                                                                                        item.file
                                                                                                                    )
                                                                                                                    : (item.file
                                                                                                                        ?.originalname,
                                                                                                                        `${process.env.REACT_APP_API_ENDPOINT}/${item.file?.path}`)
                                                                                                            }
                                                                                                            download={
                                                                                                                item.file
                                                                                                                    ?.filename
                                                                                                            }
                                                                                                            target="_blank"
                                                                                                        >
                                                                                                            <span>
                                                                                                                {
                                                                                                                    item.file
                                                                                                                        ?.originalname
                                                                                                                }
                                                                                                            </span>
                                                                                                            <DownloadIcon />
                                                                                                        </a>
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <a
                                                                                                            className="downloadables "
                                                                                                            href={
                                                                                                                item.file?.name
                                                                                                                    ? URL.createObjectURL(
                                                                                                                        item.file
                                                                                                                    )
                                                                                                                    : (item.file
                                                                                                                        ?.originalname,
                                                                                                                        `${process.env.REACT_APP_API_ENDPOINT}/${item.file?.path}`)
                                                                                                            }
                                                                                                            download={
                                                                                                                item.file
                                                                                                                    ?.filename
                                                                                                            }
                                                                                                            target="_blank"
                                                                                                        >
                                                                                                            {item.file?.name}
                                                                                                            <img
                                                                                                                src={
                                                                                                                    downloadImage
                                                                                                                }
                                                                                                                height="15px"
                                                                                                            />
                                                                                                        </a>
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="buttons">
                                                                                        <div
                                                                                            className="delete !text-red-500"
                                                                                            onClick={() =>
                                                                                                handleQualityDocumentDelete(
                                                                                                    i
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Delete
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {billData?.status == 'pending for approval' ?
                        <>
                            <button
                                className="req-quote-btn"
                                onClick={handleBillUpdateClick}
                            >
                                Update
                            </button>
                        </> : <></>}

                    <button
                        className="req-quote-btn"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default BillDisplayModal